import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import global, { LOGOUT } from './App/reducer';
import signIn from './App/SignIn/reducer';
import dashboard from './App/Dashboard/reducer';
// import merchantTransactions from './App/MerchantTransaction/reducer';
import commissionPayouts from './App/CommissionPayouts/reducer';
import partners from './App/Partners/reducer';
import account from './App/Account/reducer';
import marketing from './App/Marketing/reducer';
import modalConductor from './modules/ModalConductor/reducer';
import merchants from './App/Merchants/reducer';
// import merchantRegistrations from './App/MerchantRegistrations/reducer';
// import directMerchants from './App/Merchants/reducer';

const reducer = combineReducers({
  form: formReducer,
  global,
  modalConductor,
  // merchantTransactions,
  signIn,
  commissionPayouts,
  merchants,
  partners,
  account,
  dashboard,
  marketing
  // merchantRegistrations,
  // directMerchants
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    const { global } = state;
    state = { global };
  }

  return reducer(state, action);
};

export default rootReducer;
